export default __webpack_public_path__ + "static/media/ios_add.d623148d.svg";